import { ChangeDetectionStrategy, Component, EventEmitter, inject, input, InputSignal, Output, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslationPipeModule } from '@ogs-gmbh/ngx-translate';
import { IconModule } from "@ogs-gmbh/ngx-m3-components";
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faEye, faEyeSlash, faImage, faThumbTack, faXmark } from '@fortawesome/pro-light-svg-icons';
import { NgTemplateOutlet } from '@angular/common';
import { HEADER_DISPLAY_TYPES } from '@shared/components/table-implementation/bcl-table-data/header-display-type';
import { TableColumn } from '@shared/components/table-implementation/types/column/header.type';

@Component({
  selector: 'app-overview-menu-field',
  standalone: true,
  imports: [ IconModule, TranslationPipeModule, MatButtonModule, NgTemplateOutlet ],
  templateUrl: './overview-menu-field.component.html',
  styleUrl: './overview-menu-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverviewMenuFieldComponent implements OnInit {
  private _faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  @Output() public readonly visibilityClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() public readonly fixedClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  public header: InputSignal<TableColumn> = input.required();

  protected headerDisplayTypes: typeof HEADER_DISPLAY_TYPES = HEADER_DISPLAY_TYPES;

  public ngOnInit (): void {
    this._faIconLibrary.addIcons(faEye, faEyeSlash, faImage, faThumbTack, faXmark);
  }

  protected onVisibilityClick (): void {
    this.visibilityClicked.emit(!this.header().options.isVisible);
  }

  protected onFixedClick (): void {
    this.fixedClicked.emit(!this.header().options.isFixed);
  }
}
